import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let SearchComp;

class Search extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: SearchComp };  
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/lyte-components/search-comp" */
            "../../../components/javascript/lyte-components/search-comp"
        ).then(function(res) {
            SearchComp = res.SearchComp;
        }));

        
;
    }
}

export {Search};

